<template>
    <div>
        <mobile-template>
            <div class="p-6 bg-white">
                <h1 class="text-2xl font-bold mb-4 pb-4 border-b">Nouvelle intervention</h1>
                <!-- <add-intervention-stepper
                    @intervention-created="onInterventionCreated"
                    @chantier-created="onChantierCreated"
                /> -->
                <chantier-init
                @slots-created="onChantierCreated"
                />
            </div>
        </mobile-template>
    </div>
</template>

<script>
// import AddInterventionStepper from "./../Intervention/Components/AddInterventionStepper.vue";
import ChantierInit from "./../Chantier/Components/ChantierInit.vue";

export default {
    name: "NewInterventionWidget",
    components: {
        // AddInterventionStepper,
        ChantierInit
    },
    methods: {
        onInterventionCreated({ intervention }) {
            this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier');
        },
        onChantierCreated({ chantier }) {
            // optionnel : navigate vers le chantier, afficher une vue, etc.
        },
    }
}
</script>

<style scoped>
html, body {
    background: #fff !important;
}
</style>